import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeNomeConsultaAdvertenciaFornecedor: [],
    removeCpfConsultaAdvertenciaFornecedor: [],
    removeCnpjConsultaAdvertenciaFornecedor: [],
    removeStatusConsultaAdvertenciaFornecedor: [],
    setMostraAplicarFiltroConsultaAdvertenciaFornecedor: [],
    limpaFiltroConsultaAdvertenciaFornecedor: [],
    aplicarFiltroConsultaAdvertenciaFornecedor: ['filtro'],
})

const INITIAL_STATE = {
    nome: '',
    cpf: '',
    cnpj: '',
    mostraAplicarFiltro: false,
    status: '',
}

const removeNome = (state = INITIAL_STATE, action) => {
    return { ...state, nome: '', mostraAplicarFiltro: true }
}

const removeCpf = (state = INITIAL_STATE, action) => {
    return { ...state, cpf: '', mostraAplicarFiltro: true }
}

const removeCnpj = (state = INITIAL_STATE, action) => {
    return { ...state, cnpj: '', mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const removeStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: '', mostraAplicarFiltro: true }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_NOME_CONSULTA_ADVERTENCIA_FORNECEDOR]: removeNome,
    [Types.REMOVE_CPF_CONSULTA_ADVERTENCIA_FORNECEDOR]: removeCpf,
    [Types.REMOVE_CNPJ_CONSULTA_ADVERTENCIA_FORNECEDOR]: removeCnpj,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_ADVERTENCIA_FORNECEDOR]: setMostraAplicarFiltro,
    [Types.REMOVE_STATUS_CONSULTA_ADVERTENCIA_FORNECEDOR]: removeStatus,
    [Types.LIMPA_FILTRO_CONSULTA_ADVERTENCIA_FORNECEDOR]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_ADVERTENCIA_FORNECEDOR]: aplicarFiltro,
})
